<template>
	<svg
		:id="id"
		class="LogoMacaulayMobile"
		:class="classes"
		viewBox="0 0 274 33"
		role="img"
		:aria-labelledby="'logo-macaulay-mobile-title-' + id"
	>
		<title :id="'logo-macaulay-mobile-title-' + id">Macaulay Library logo</title>
		<g fill="none" fill-rule="evenodd">
			<path
				fill="#FFF"
				d="M51.5 6c-.4-.2-1.7-.5-2.2-.7-.5-.2-2.1-.6-2.5-.7-.2-.2-.3-.4-.5-.5-1.5-1.6-3.7-2.5-6-2.5-2.6 0-4.5.9-5.2 1.2H1.2v1c0 1.4 1.7 2.5 3.9 2.5h9.3l7.6 5.3v8.2c0 4 2.1 7.7 5.7 9.8 3 1.7 4.8 1.9 6.8 1.9h1.9V14.4l.6-.5 8.3-6.1s4.4-.3 5.5-.3c.6 0 1.3-.1 1.8-.2.4-.1.6-.2.6-.3 0-.1-.1-.2-.2-.3-.1-.1-.7-.4-1.5-.7z"
			/>
			<path
				fill="#000"
				fill-rule="nonzero"
				d="M51.7 6.7s-3.9-1-5.5-1.2c0 0-6 3.2-7.7 4.3-1.7 1.1-2 2.7-2.1 3.3L45 6.8h6.7c.2 0 0-.1 0-.1z"
			/>
			<path
				fill="#000"
				fill-rule="nonzero"
				d="M37.8 9.2c1.8-1.2 7.8-4.5 7.8-4.5-1-1.1-2.9-2.2-5.3-2.2-2.9 0-5 1.2-5 1.2H2.2c0 .9 1.3 1.6 2.9 1.6h9.6l8.2 5.8v8.7c0 3.8 2 7.1 5.2 9 3.2 1.9 4.9 1.8 7.3 1.8V13.9c0-1.5.5-3.4 2.4-4.7zm4.6-4.6c.3 0 .6.3.6.6s-.3.6-.6.6-.6-.3-.6-.6c0-.4.3-.6.6-.6zm-6.9 3.1l3.8-2.1 1.7.1-5.4 3v-1h-.1z"
			/>
			<path fill="#F5E614" fill-rule="nonzero" d="M14.7 5.3h13.8c-3.1 0-5.6 2.5-5.6 5.8l-8.2-5.8z" />
			<path fill="#E60000" fill-rule="nonzero" d="M44.9 5.1c-1.1-.9-2.8-1.8-4.9-1.8v-.8h.3c2.4 0 4.3 1.1 5.3 2.2l-.7.4z" />
			<path fill="#E60000" d="M45 6.8l-6 4.4s-.1-.6.8-1.4c.9-.7 6.4-4.4 6.4-4.4L45 6.8z" />
			<path
				fill="#FFF"
				fill-rule="nonzero"
				d="M32.9 18.1v-3c0-1.2-.5-2.1-1.7-2.9l-4.9-3.5c-.6.6-.9 1.4-.9 2.3 0 1.1.5 2.1 1.4 2.7 0 .1 6.1 4.4 6.1 4.4z"
			/>
			<path
				class="LogoMacaulayMobile-text"
				fill="#000"
				fill-rule="nonzero"
				d="M258.7 10h2.9l3.9 10.4h.1l3.8-10.4h2.7l-6.3 16.1c-.2.6-.5 1.1-.7 1.6-.2.5-.5.9-.9 1.2-.3.3-.7.6-1.2.8-.5.2-1.1.3-1.7.3-.4 0-.7 0-1.1-.1-.4-.1-.7-.1-1.1-.3l.3-2.3c.5.2 1 .3 1.5.3.4 0 .7-.1 1-.2.3-.1.5-.3.7-.4.2-.2.4-.4.5-.7.1-.3.3-.6.4-.9l.8-2.1-5.6-13.3zm-9.1 0h2.5v2h.1c.2-.4.4-.7.7-1 .3-.3.6-.5.9-.7.3-.2.7-.4 1.1-.5.4-.1.8-.2 1.2-.2.4 0 .8.1 1.1.2l-.1 2.7c-.2-.1-.4-.1-.6-.1-.2 0-.4-.1-.6-.1-1.2 0-2.2.3-2.8 1-.7.7-1 1.8-1 3.2v6.7h-2.5V10zm-14.1 1.6c.7-.7 1.5-1.1 2.5-1.5.9-.3 1.9-.5 2.8-.5 1 0 1.8.1 2.5.4.7.2 1.3.6 1.7 1 .4.4.8.9 1 1.4.2.5.3 1.1.3 1.7v8.1s0 .8.1 1.1h-2.2c-.1-.7-.1-1.3-.1-2h-.1c-.6.9-1.2 1.5-2 1.8-.8.4-1.7.5-2.7.5-.6 0-1.2-.1-1.8-.3-.6-.2-1-.4-1.5-.8s-.8-.8-1-1.2c-.2-.5-.4-1.1-.4-1.7 0-.9.2-1.6.6-2.2.4-.6.9-1.1 1.6-1.4.7-.4 1.4-.6 2.3-.8.9-.2 1.8-.2 2.8-.2h1.8v-.6c0-.3-.1-.7-.2-1-.1-.3-.3-.6-.6-.9-.3-.3-.6-.5-1-.6-.4-.2-.9-.2-1.4-.2-.5 0-.9 0-1.3.1s-.7.2-1 .3c-.3.1-.6.3-.8.5-.2.2-.5.4-.7.5l-1.2-1.5zm7.1 5.3c-.6 0-1.2 0-1.8.1-.6.1-1.2.2-1.7.4s-.9.4-1.3.8c-.3.3-.5.8-.5 1.3 0 .8.3 1.3.8 1.7.5.4 1.2.5 2.1.5.7 0 1.3-.1 1.8-.3.5-.2.9-.5 1.2-.9.3-.4.5-.8.6-1.2.1-.5.2-.9.2-1.4v-.8h-1.4v-.2zm-17-6.9h2.5v2h.1c.2-.4.4-.7.7-1 .3-.3.6-.5.9-.7.3-.2.7-.4 1.1-.5.4-.1.8-.2 1.2-.2.4 0 .8.1 1.1.2l-.1 2.7c-.2-.1-.4-.1-.6-.1-.2 0-.4-.1-.6-.1-1.2 0-2.2.3-2.8 1-.7.7-1 1.8-1 3.2v6.7h-2.5V10zm-16.8-7.9h2.5v9.8h.1c.4-.7 1.1-1.2 1.9-1.6.8-.4 1.7-.6 2.7-.6 1 0 2 .2 2.8.5.8.4 1.5.8 2.1 1.5.6.6 1 1.4 1.4 2.2.4.8.5 1.8.5 2.8 0 1-.2 1.9-.5 2.7-.3.8-.8 1.6-1.4 2.2-.6.6-1.3 1.1-2.1 1.5-.8.4-1.8.5-2.8.5-.9 0-1.8-.2-2.6-.6-.8-.4-1.5-.9-2-1.7h-.1v1.9h-2.5V2.1zm6.9 19.2c.7 0 1.3-.1 1.8-.3.5-.2 1-.6 1.4-1 .4-.4.7-.9.9-1.5.2-.6.3-1.2.3-1.9s-.1-1.3-.3-1.9c-.2-.6-.5-1.1-.9-1.5-.4-.4-.8-.7-1.4-1-.5-.2-1.1-.4-1.8-.4s-1.3.1-1.8.4c-.5.2-1 .6-1.4 1-.4.4-.7.9-.9 1.5-.2.6-.3 1.2-.3 1.9s.1 1.3.3 1.9c.2.6.5 1.1.9 1.5.4.4.8.7 1.4 1 .6.2 1.2.3 1.8.3zM202 10h2.5v13.3H202V10zm-.6-4.7c0-.5.2-.9.5-1.3.4-.4.8-.5 1.3-.5s.9.2 1.3.5c.4.4.5.8.5 1.3s-.2.9-.5 1.3c-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5c-.3-.4-.5-.8-.5-1.3zm-13.8-1.8h2.7v17.3h9.1v2.5h-11.8V3.5zM162.9 10h2.9l3.9 10.4h.1l3.8-10.4h2.7L170 26.2c-.2.6-.5 1.1-.7 1.6-.2.5-.5.9-.9 1.2-.3.3-.7.6-1.2.8-.5.2-1.1.3-1.7.3-.4 0-.7 0-1.1-.1-.4-.1-.7-.1-1.1-.3l.3-2.3c.5.2 1 .3 1.5.3.4 0 .7-.1 1-.2.3-.1.5-.3.7-.4.2-.2.4-.4.5-.7.1-.3.3-.6.4-.9l.8-2.1-5.6-13.4zm-13.2 1.6c.7-.7 1.5-1.1 2.5-1.5.9-.3 1.9-.5 2.8-.5 1 0 1.8.1 2.5.4.7.2 1.3.6 1.7 1 .4.4.8.9 1 1.4.2.5.3 1.1.3 1.7v8.1s0 .8.1 1.1h-2.2c-.1-.7-.1-1.3-.1-2h-.1c-.6.9-1.2 1.5-2 1.8-.8.4-1.7.5-2.7.5-.6 0-1.2-.1-1.8-.3-.6-.2-1-.4-1.5-.8s-.8-.8-1-1.2c-.2-.5-.4-1.1-.4-1.7 0-.9.2-1.6.6-2.2.4-.6.9-1.1 1.6-1.4.7-.4 1.4-.6 2.3-.8.9-.2 1.8-.2 2.8-.2h1.8v-.6c0-.3-.1-.7-.2-1-.1-.3-.3-.6-.6-.9-.3-.3-.6-.5-1-.6-.4-.2-.9-.2-1.4-.2-.5 0-.9 0-1.3.1s-.7.2-1 .3c-.3.1-.6.3-.8.5-.2.2-.5.4-.7.5l-1.2-1.5zm7.1 5.3c-.6 0-1.2 0-1.8.1-.6.1-1.2.2-1.7.4s-.9.4-1.3.8c-.3.3-.5.8-.5 1.3 0 .8.3 1.3.8 1.7.5.4 1.2.5 2.1.5.7 0 1.3-.1 1.8-.3.5-.2.9-.5 1.2-.9.3-.4.5-.8.6-1.2.1-.5.2-.9.2-1.4v-.8h-1.4v-.2zM143.7 2.1h2.5v21.2h-2.5V2.1zm-3.2 21.2H138v-2c-.3.7-.9 1.3-1.7 1.7-.8.4-1.7.7-2.7.7-.7 0-1.3-.1-1.8-.3-.6-.2-1.1-.5-1.5-.9-.4-.4-.8-.9-1-1.6-.2-.7-.4-1.4-.4-2.3V10h2.5v7.8c0 .6.1 1.1.3 1.6.2.4.4.8.7 1.1.3.3.6.5 1 .6.4.1.7.2 1.1.2.5 0 1-.1 1.5-.3.4-.2.8-.4 1.2-.8.3-.4.6-.8.8-1.4.2-.6.3-1.2.3-2V10h2.5v13.3h-.3zm-25.9-11.7c.7-.7 1.5-1.1 2.5-1.5.9-.3 1.9-.5 2.8-.5 1 0 1.8.1 2.5.4.7.2 1.3.6 1.7 1 .4.4.8.9 1 1.4.2.5.3 1.1.3 1.7v8.1s0 .8.1 1.1h-2.2c-.1-.7-.1-1.3-.1-2h-.1c-.6.9-1.2 1.5-2 1.8-.8.4-1.7.5-2.7.5-.6 0-1.2-.1-1.8-.3-.6-.2-1-.4-1.5-.8s-.8-.8-1-1.2c-.2-.5-.4-1.1-.4-1.7 0-.9.2-1.6.6-2.2.4-.6.9-1.1 1.6-1.4.7-.4 1.4-.6 2.3-.8.9-.2 1.8-.2 2.8-.2h1.8v-.6c0-.3-.1-.7-.2-1-.1-.3-.3-.6-.6-.9-.3-.3-.6-.5-1-.6-.4-.2-.9-.2-1.4-.2-.5 0-.9 0-1.3.1s-.7.2-1 .3c-.3.1-.6.3-.8.5-.2.2-.5.4-.7.5l-1.2-1.5zm7.1 5.3c-.6 0-1.2 0-1.8.1-.6.1-1.2.2-1.7.4s-.9.4-1.3.8c-.3.3-.5.8-.5 1.3 0 .8.3 1.3.8 1.7.5.4 1.2.5 2.1.5.7 0 1.3-.1 1.8-.3.5-.2.9-.5 1.2-.9.3-.4.5-.8.6-1.2.1-.5.2-.9.2-1.4v-.8h-1.4v-.2zM110 13.6c-.5-.5-1-.9-1.5-1.1-.5-.2-1.1-.4-1.8-.4s-1.3.1-1.8.4c-.5.3-.9.6-1.3 1-.3.4-.6.9-.8 1.5-.2.6-.3 1.2-.3 1.8 0 .6.1 1.2.3 1.8.2.6.5 1 .9 1.4.4.4.8.7 1.3 1 .5.2 1.1.3 1.8.3s1.3-.1 1.8-.4c.5-.3 1-.6 1.4-1.1l1.8 1.8c-.7.7-1.4 1.3-2.3 1.6-.9.3-1.8.5-2.8.5-1 0-2-.2-2.8-.5-.8-.3-1.6-.8-2.2-1.4-.6-.6-1.1-1.3-1.4-2.2-.3-.8-.5-1.8-.5-2.8 0-1 .2-2 .5-2.8.3-.8.8-1.6 1.4-2.2.6-.6 1.3-1.1 2.2-1.4.8-.3 1.8-.5 2.8-.5 1 0 1.9.2 2.8.5.9.3 1.7.9 2.3 1.6l-1.8 1.6zm-23.3-2c.7-.7 1.5-1.1 2.5-1.5.9-.3 1.9-.5 2.8-.5 1 0 1.8.1 2.5.4.7.2 1.3.6 1.7 1 .4.4.8.9 1 1.4.2.5.3 1.1.3 1.7v8.1s0 .8.1 1.1h-2.2c-.1-.7-.1-1.3-.1-2h-.1c-.6.9-1.2 1.5-2 1.8-.8.4-1.7.5-2.7.5-.6 0-1.2-.1-1.8-.3-.6-.2-1-.4-1.5-.8s-.8-.8-1-1.2c-.2-.5-.4-1.1-.4-1.7 0-.9.2-1.6.6-2.2.4-.6.9-1.1 1.6-1.4.7-.4 1.4-.6 2.3-.8.9-.2 1.8-.2 2.8-.2h1.8v-.6c0-.3-.1-.7-.2-1-.1-.3-.3-.6-.6-.9-.3-.3-.6-.5-1-.6-.4-.2-.9-.2-1.4-.2-.5 0-.9 0-1.3.1s-.7.2-1 .3c-.3.1-.6.3-.8.5-.2.2-.5.4-.7.5l-1.2-1.5zm7.1 5.3c-.6 0-1.2 0-1.8.1-.6.1-1.2.2-1.7.4s-.9.4-1.3.8c-.3.3-.5.8-.5 1.3 0 .8.3 1.3.8 1.7.5.4 1.2.5 2.1.5.7 0 1.3-.1 1.8-.3.5-.2.9-.5 1.2-.9.3-.4.5-.8.6-1.2.1-.5.2-.9.2-1.4v-.8h-1.4v-.2zM62.6 3.5h4l6.3 15h.1l6.2-15h4v19.8h-2.7V7h-.1l-6.7 16.3H72L65.3 7h-.1v16.3h-2.7V3.5h.1z"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {
		classes() {
			return {
				'LogoMacaulayMobile--reverse': this.reverse,
				'LogoMacaulayMobile--xs': this.size === 'xs',
				'LogoMacaulayMobile--sm': this.size === 'sm',
				'LogoMacaulayMobile--lg': this.size === 'lg',
				'LogoMacaulayMobile--xl': this.size === 'xl',
				'LogoMacaulayMobile--responsive': this.size === 'responsive',
			};
		},
	},

	props: {
		/**
		 * unique ID automatically generated if not set
		 */
		id: {
			type: String,
			default: 'id-' + Math.random().toString(36).substr(2, 9),
		},
		/**
		 * for use on dark background
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * can be xs, sm, lg, xl, or responsive
		 */
		size: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss">
/* --------------------------------
	Macaulay mobile logo (with sapsucker)
-------------------------------- */

/* Original dimensions of svg - used for calculating width from height */
$logo-macaulay-mobile-orig-w: 274;
$logo-macaulay-mobile-orig-h: 33;
/* Units to be used below */
$logo-macaulay-mobile-units: rem;

/* Default logo style */
.LogoMacaulayMobile {
	$logo-macaulay-mobile-h-md: 1.5;
	$logo-macaulay-mobile-w-md: calc-width-from-height(
		$logo-macaulay-mobile-orig-w,
		$logo-macaulay-mobile-orig-h,
		$logo-macaulay-mobile-h-md
	);
	height: #{$logo-macaulay-mobile-h-md}#{$logo-macaulay-mobile-units};
	width: #{$logo-macaulay-mobile-w-md}#{$logo-macaulay-mobile-units};
	max-width: 100%; /* Ensure svg will shrink with container */
	vertical-align: middle; /* Safety if width or height are overridden out of ratio */
}

/* ----------------
	Variants
---------------- */

/* Reverse variant for dark backgrounds */
.LogoMacaulayMobile--reverse {
	.LogoMacaulayMobile-text {
		fill: #fff;
	}
}

/* Extra small (xs) variant */
.LogoMacaulayMobile--xs {
	$logo-macaulay-mobile-h-xs: 1;
	$logo-macaulay-mobile-w-xs: calc-width-from-height(
		$logo-macaulay-mobile-orig-w,
		$logo-macaulay-mobile-orig-h,
		$logo-macaulay-mobile-h-xs
	);
	height: #{$logo-macaulay-mobile-h-xs}#{$logo-macaulay-mobile-units};
	width: #{$logo-macaulay-mobile-w-xs}#{$logo-macaulay-mobile-units};
}

/* Small (sm) variant */
.LogoMacaulayMobile--sm {
	$logo-macaulay-mobile-h-sm: 1.25;
	$logo-macaulay-mobile-w-sm: calc-width-from-height(
		$logo-macaulay-mobile-orig-w,
		$logo-macaulay-mobile-orig-h,
		$logo-macaulay-mobile-h-sm
	);
	height: #{$logo-macaulay-mobile-h-sm}#{$logo-macaulay-mobile-units};
	width: #{$logo-macaulay-mobile-w-sm}#{$logo-macaulay-mobile-units};
}

/* Large (lg) variant */
.LogoMacaulayMobile--lg {
	$logo-macaulay-mobile-h-lg: 2;
	$logo-macaulay-mobile-w-lg: calc-width-from-height(
		$logo-macaulay-mobile-orig-w,
		$logo-macaulay-mobile-orig-h,
		$logo-macaulay-mobile-h-lg
	);
	height: #{$logo-macaulay-mobile-h-lg}#{$logo-macaulay-mobile-units};
	width: #{$logo-macaulay-mobile-w-lg}#{$logo-macaulay-mobile-units};
}

/* Extra large (xl) variant */
.LogoMacaulayMobile--xl {
	$logo-macaulay-mobile-h-xl: 2.5;
	$logo-macaulay-mobile-w-xl: calc-width-from-height(
		$logo-macaulay-mobile-orig-w,
		$logo-macaulay-mobile-orig-h,
		$logo-macaulay-mobile-h-xl
	);
	height: #{$logo-macaulay-mobile-h-xl}#{$logo-macaulay-mobile-units};
	width: #{$logo-macaulay-mobile-w-xl}#{$logo-macaulay-mobile-units};
}
</style>